import type { ThemeOptions } from "@material-ui/core"
import { useEffect, useState } from "react"
import { useOpco } from "."
import { themeOverwriteNoordhoff, themeOverwritePlantyn } from "./../config/ThemeOverwrite"
import { Opco } from "./../models/types"

export function useOpcoTheme(): ThemeOptions {
  const opco: Opco = useOpco()
  const [theme, setTheme] = useState<ThemeOptions>(themeOverwriteNoordhoff)

  useEffect(() => {
    selectThemeByOpco(opco)
  }, [opco])

  function selectThemeByOpco(opco: Opco): void {
    switch (opco) {
      case Opco.Noordhoff:
        setTheme(themeOverwriteNoordhoff)
        break
      case Opco.Plantyn:
        setTheme(themeOverwritePlantyn)
        break
    }
  }

  return theme
}
